import { defineMessages } from "react-intl";
const messages = defineMessages({
    communityFeatures: {
        id: "app.admin.editCommunity.features.text",
        defaultMessage: "Features",
    },
    prospectIntelligenceFeature: {
        id: "app.admin.editCommunity.features.prospectIntelligence.text",
        defaultMessage: "Prospect Intelligence",
    },
    analyticsFeature: {
        id: "app.admin.editCommunity.features.analytics.text",
        defaultMessage: "Analytics",
    },
    SGTFeature: {
        id: "app.admin.editCommunity.features.sgt.text",
        defaultMessage: "SGT",
    },
    SGTCasaFeature: {
        id: "app.admin.editCommunity.features.sgt.casa.text",
        defaultMessage: "SGT Assistant",
    },
    VTCasaFeature: {
        id: "app.admin.editCommunity.features.vt.casa.text",
        defaultMessage: "Virtual Tour Assistant",
    },
    WidgetCasaFeature: {
        id: "app.admin.editCommunity.features.widget.casa.text",
        defaultMessage: "Website Widget Assistant",
    },
    MagicButtonFeature: {
        id: "app.admin.editCommunity.features.magicButton.text",
        defaultMessage: "Magic Button",
    },
    AutoscanFeature: {
        id: "app.admin.editCommunity.features.autoScan.text",
        defaultMessage: "AutoScan",
    },
    SelfScanFeature: {
        id: "app.admin.editCommunity.features.selfScan.text",
        defaultMessage: "Self-Scanning",
    },
});
export default messages;
